import { PrimaryControlsStripLeading } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.back";
import {
  ToolbarActionsLane,
  ToolbarMoreActions,
} from "@-/dev.improve.haniverse.components.ui.toolbar.button.icon";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { PrimaryControlsStripToolbar } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.toolbar";
import { CollectionsLayoutContext } from "#collections-layout-context";
import { View } from "@-/com.npmjs.react-native";

export function CollectionsLayoutToolbar() {
  const [center, trailing] = useContextSelectors(
    CollectionsLayoutContext,
    (context) => context.center,
    (context) => context.trailing,
  );

  return (
    <PrimaryControlsStripToolbar className="relative">
      <View className="absolute inset-0 items-center pt-2.25" pointerEvents="box-none">
        {center}
      </View>
      <ToolbarActionsLane className="gap-1">
        <PrimaryControlsStripLeading>
          <ToolbarMoreActions>{trailing}</ToolbarMoreActions>
        </PrimaryControlsStripLeading>
      </ToolbarActionsLane>
    </PrimaryControlsStripToolbar>
  );
}
